'use client';

import { ReactNode } from 'react';
import { useMounted } from '@/utils/use-mounted';
import { useExperimentVersion } from './experiments-provider';
interface ExperimentWrapperProps {
  experimentTitle: string;
  versions: Record<string, ReactNode | ((experimentTitle: string, version: string) => ReactNode)>;
  fallback: ReactNode;
}
export function ExperimentWrapper({
  experimentTitle,
  versions,
  fallback
}: ExperimentWrapperProps) {
  const isMounted = useMounted();
  const version = useExperimentVersion(experimentTitle);
  if (!isMounted || !version || !(version in versions)) {
    return <>{fallback}</>;
  }
  const activeVersion = versions[version];
  if (typeof activeVersion === 'function') {
    return activeVersion(experimentTitle, version);
  }
  return <>{activeVersion}</>;
}